import React from 'react'

export default function Logo({ alwaysShowText = false }) {

    return (
        <>
            <div className='logo' >
                <img src='/assets/images/logo.webp' alt='logo' />
            </div>
        </>
    )
}
